import Vue from 'vue';
import Vuex from 'vuex';
//import { createStore } from 'vuex';

import dataLists from './modules/dataLists';
import display from './modules/display';
import security from './modules/security';
import report from './modules/report';
import results from './modules/results';
import selModel from './modules/selModel';
import loadedControls from './modules/loadedControls';

import 'es6-promise/auto';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        dataLists,
        display,
        report,
        security,
        results,
        selModel,
        loadedControls
    }
})
